import { createFileRoute } from "@tanstack/react-router";

import { Sobre } from "@/components/itv/pages/Sobre";
import { carregarPaginaSimples } from "@/lib/pagina-simples";

const PATH = "/sobre/";
const TITLE = "Dr. Thiago Viana: Médico Nutrólogo e do Esporte";
const DESCRIPTION =
  "Conheça o Dr. Thiago Viana, formado pela UNIFESP-EPM, com títulos de nutrologia, medicina do esporte e ortopedia. Conheça sua trajetória e método.";

export const Route = createFileRoute("/sobre")({
  loader: () => carregarPaginaSimples(PATH, TITLE, DESCRIPTION),
  head: ({ loaderData }) => ({
    meta: loaderData?.meta ?? [],
    links: loaderData?.links ?? [],
  }),
  component: Page,
});

function Page() {
  return <Sobre />;
}
